// LTO popup (template-parts/lto-popup.php)
(function () {
	let overlay, popup, previousFocus;

	const isOpen = () => document.body.classList.contains("lto-popup-open");

	function showLtoPopup() {
		if (isOpen() || document.querySelector(".fancybox-is-open")) return;

		previousFocus = document.activeElement;
		overlay.style.display = "flex";
		document.body.classList.add("lto-popup-open");
		popup.focus({ preventScroll: true });
	}

	function hideLtoPopup() {
		overlay.style.display = "none";
		document.body.classList.remove("lto-popup-open");

		if (previousFocus && document.contains(previousFocus)) {
			previousFocus.focus({ preventScroll: true });
		}
		previousFocus = null;
	}

	function trapFocus(e) {
		const focusable = popup.querySelectorAll("a[href], button");
		if (!focusable.length) return;

		const first = focusable[0];
		const last = focusable[focusable.length - 1];
		const active = document.activeElement;
		const leavingStart = e.shiftKey && (active === first || active === popup);
		const leavingEnd = !e.shiftKey && active === last;

		if (leavingStart || leavingEnd) {
			e.preventDefault();
			(leavingStart ? last : first).focus();
		}
	}

	function init() {
		overlay = document.querySelector(".lto-popup-overlay");
		popup = overlay?.querySelector(".lto-popup");
		if (!popup) return;

		setTimeout(showLtoPopup, 1000);

		overlay.addEventListener("click", (e) => {
			if (e.target === overlay || e.target.closest(".close-icon")) {
				hideLtoPopup();
			}
		});

		document.addEventListener("keydown", (e) => {
			if (!isOpen()) return;
			if (e.key === "Escape") hideLtoPopup();
			if (e.key === "Tab") trapFocus(e);
		});
	}

	if (document.readyState === "complete") {
		init();
	} else {
		window.addEventListener("load", init);
	}
})();
